export const formatDate = (date: any) => {
    if (date && date.toDate instanceof Function) {
      return date.toDate();
    }
    return null;
  };
